// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RiseOutlinedSvg from "@fishx/icons-svg/es/asn/RiseOutlined";
import FishxIcon from '../components/FishxIcon';

var RiseOutlined = function RiseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RiseOutlinedSvg
  }));
};

RiseOutlined.displayName = 'RiseOutlined';
export default React.forwardRef(RiseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RiseOutlined.js
// module id = 4023
// module chunks = 0